export class UpdateDlsgPolicyRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceInclusion",
            "baseName": "resourceInclusion",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "policyPlan",
            "baseName": "policyPlan",
            "type": "DlsgPolicyPlan",
            "format": ""
        },
        {
            "name": "scheduleMode",
            "baseName": "scheduleMode",
            "type": "ScheduleMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateDlsgPolicyRequest.attributeTypeMap;
    }
    constructor() {
    }
}
